/* hs-content.js — content behaviours shared by every hs- section.
   One owner per behaviour (R-36): accordions ([data-hs-acc]) and the
   "BUY NOW & SAVE" scroll-to-top links ([data-hs-scroll-top], the design's own
   #top + window.scrollTo({top:0}) — never scrollIntoView). Delegated once per page. */
(function () {
  'use strict';
  if (window.__pgContent) return; window.__pgContent = true;
  document.addEventListener('click', function (e) {
    var q = e.target.closest && e.target.closest('[data-hs-acc]');
    if (q) {
      var panel = document.getElementById(q.getAttribute('aria-controls'));
      var open = q.getAttribute('aria-expanded') === 'true';
      q.setAttribute('aria-expanded', open ? 'false' : 'true');
      if (panel) panel.hidden = open;
      return;
    }
    var top = e.target.closest && e.target.closest('[data-hs-scroll-top]');
    if (top) {
      e.preventDefault();
      var smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: 0, behavior: smooth ? 'smooth' : 'auto' });
    }
  });
})();
